import { COLORS, pickThemeFontStyles } from '@/theme';
import styled from 'styled-components';

export const StyledHeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  padding: 2rem 2rem 0;
  padding-bottom: 0;
  align-items: start;
  background-color: ${COLORS.GRAY};
  border-bottom: 1px solid ${COLORS.LIGHT_GRAY};
`;

export const StyledPageTitle = styled.div`
  ${pickThemeFontStyles('30', '30', 'BOLD')};
  color: ${COLORS.BLACK_PRIMARY};
`;
